// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22pf1","delete":"styles_delete__upuIZ","update":"styles_update__3pKoB","add":"styles_add__2UKZH"};